/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    IncreaseInPremium: {
        id: 'cep.components.sgEndorsementQuotePage.IncreaseInPremium',
        defaultMessage: 'Increase in premium'
    },
    ReductionInPremium: {
        id: 'cep.components.sgEndorsementQuotePage.ReductionInPremium',
        defaultMessage: 'Reduction in premium'
    },
    CostToPay: {
        id: 'cep.components.sgEndorsementQuotePage.CostToPay',
        defaultMessage: 'Cost to pay:'
    },
    Refund: {
        id: 'cep.components.sgEndorsementQuotePage.Refund',
        defaultMessage: 'Refund:'
    },
    AmountToBeRefunded: {
        id: 'cep.components.sgEndorsementQuotePage.AmountToBeRefunded',
        defaultMessage: 'Amount to be refunded back to you:'
    },
    ZeroPounds: {
        id: 'cep.components.sgEndorsementQuotePage.ZeroPounds',
        defaultMessage: '£0'
    },
    NoRefund: {
        id: 'cep.components.sgEndorsementQuotePage.NoRefund',
        defaultMessage: '* As per the terms of your policy, the reduction in premium will not be refunded, as it does not exceed £5.'
    },
    NoCost: {
        id: 'cep.components.sgEndorsementQuotePage.NoCost',
        defaultMessage: '* As the increase in premium is £5 or less, as per the terms of your policy, you will not be required to pay this.'
    },
    FullPremium: {
        id: 'cep.components.sgEndorsementQuotePage.FullPremium',
        defaultMessage: 'Based on today\'s change the full premium for this policy year would be {annualPremium}.'
    },
    SagaPlusRenewal: {
        id: 'cep.components.sgEndorsementQuotePage.SagaPlusRenewal',
        defaultMessage: 'If you are in the first or second year of our 3-year Fixed Price cover and there are no claims or changes, this will be your premium at renewal.'
    },
    MonthlyPremiumChangeLabel: {
        id: 'cep.components.sgEndorsementQuotePage.MonthlyPremiumChangeLabel',
        defaultMessage: 'Premium:'
    },
    MonthlyInterestChangeLabel: {
        id: 'cep.components.sgEndorsementQuotePage.MonthlyInterestChangeLabel',
        defaultMessage: 'Charge for credit:'
    },
    PriceDecreaseAnnual: {
        id: 'cep.components.sgEndorsementQuotePage.PriceDecreaseAnnual',
        defaultMessage: 'This will be refunded back to your current payment details. If this is not possible, we will send you a cheque.  This could take up to 10 working days.'
    },
    PriceDecreaseMoreInstalmentsRemaining: {
        id: 'cep.components.sgEndorsementQuotePage.PriceDecreaseMoreInstalmentsRemaining',
        defaultMessage: 'Your refund will be spread across your remaining instalments. Your next instalment will be {nextInstalment} and the remaining instalment(s) will be {remainingInstalments}.'
    },
    PriceDecreaseOneInstalmentRemaining: {
        id: 'cep.components.sgEndorsementQuotePage.PriceDecreaseOneInstalmentRemaining',
        defaultMessage: 'The refund will reduce your remaining instalment from {previousInstalment} to {newInstalment}.'
    },
    PriceDecreaseNoInstalmentsRemaining: {
        id: 'cep.components.sgEndorsementQuotePage.PriceDecreaseNoInstalmentsRemaining',
        defaultMessage: 'This will be refunded back to your current payment details. If this is not possible, we will send you a cheque.  This could take up to 10 working days.'
    },
    PriceIncreaseMoreInstalmentsRemaining: {
        id: 'cep.components.sgEndorsementQuotePage.PriceIncreaseMoreInstalmentsRemaining',
        defaultMessage: 'The additional premium will be spread across your remaining instalments. Your next instalment will be {nextInstalment} and the remaining instalment(s) will be {remainingInstalments}.'
    },
    PriceIncreaseOneInstalmentRemaining: {
        id: 'cep.components.sgEndorsementQuotePage.PriceIncreaseOneInstalmentRemaining',
        defaultMessage: 'The additional premium will increase your remaining instalment from {previousInstalment} to {newInstalment}.'
    },
    PriceIncreaseNoInstalmentsRemaining: {
        id: 'cep.components.sgEndorsementQuotePage.PriceIncreaseNoInstalmentsRemaining',
        defaultMessage: 'This amount will be taken from the payment details we currently hold within a maximum of 14 working days.'
    }
});
